import React from "react";
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Text, Tooltip, XAxis, YAxis } from "recharts";
import { useTheme } from "styled-components";

export default function LaborChart(props) {
  const { data } = props;
  const theme = useTheme();

  const yAxisLabel = (
    <Text angle={-90} dx={50} dy={180} offset={0} x={-30} y={0}>
      Number of people
    </Text>
  );

  return (
    <div>
      <ResponsiveContainer height={500} width="100%">
        <LineChart
          data={data}
          height={400}
          margin={{
            bottom: 250,
            left: 50,
            right: 50,
            top: 10,
          }}
          width={500}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis angle={-45} dataKey="name" textAnchor="end" />
          <YAxis label={yAxisLabel} />
          <Tooltip />
          <Line dataKey="Max labor" key="Max labor" stroke={theme.colors.red} type="monotone" />
          <Line dataKey="Starting labor" key="Starting labor" stroke={theme.colors.blue} type="monotone" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
